export const PAGINATION = {
  rowsPerPage: 10,
  rowsPerPageOptions: [10, 50, 100]
};
